import { authFetch } from "lib/api/authFetch";
import { normalizeApiMessage } from "lib/i18n/apiMessage";
import { BACKEND_URL } from "lib/utils/baseUrl";

export async function getImageBase64(upload_id, type) {
  if (!upload_id) {
    return {
      success: false,
      data: null,
      ...normalizeApiMessage(
        { message: "Valid upload_id is required." },
        "Valid upload_id is required.",
      ),
    };
  }

  try {
    const path = `${BACKEND_URL}/project/image_base64/${upload_id}/${type}`;

    const res = await authFetch(
      path,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      {
        refreshUrlIncludes: "auth/refresh",
      },
    );

    if (res.status === 401) {
      return {
        success: false,
        data: null,
        ...normalizeApiMessage(
          { message: "Session expired. Please sign in again." },
          "Session expired. Please sign in again.",
        ),
        messageKey: "api.auth.token.expired",
      };
    }

    const result = await res.json().catch(() => null);

    if (!result) {
      return {
        success: false,
        data: null,
        ...normalizeApiMessage(
          { message: "Failed to parse server response." },
          "Failed to parse server response.",
        ),
        messageKey: "api.common.serverError",
      };
    }

    if (!res.ok || !result.success) {
      console.warn("getImageBase64 failed:", result?.message);
      return {
        success: false,
        data: null,
        ...normalizeApiMessage(result, "Failed to load image."),
      };
    }

    return {
      success: true,
      data: result.data ?? null,
      ...normalizeApiMessage(result, "Image loaded successfully."),
    };
  } catch (error) {
    console.error("getImageBase64 request failed:", error);
    return {
      success: false,
      data: null,
      ...normalizeApiMessage(
        { message: "Server request failed." },
        "Server request failed.",
      ),
      messageKey: "api.common.networkError",
    };
  }
}
